document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-nxt-tab]');
  if (!tab) return;
  const section = tab.closest('[data-nxt-product-value]');
  if (!section) return;
  const selected = tab.dataset.nxtTab;
  section.querySelectorAll('[data-nxt-tab]').forEach((button) => {
    button.setAttribute('aria-selected', String(button === tab));
  });
  section.querySelectorAll('[data-nxt-panel]').forEach((panel) => {
    panel.hidden = panel.dataset.nxtPanel !== selected;
  });
});
